import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ActionConfirmModal from '../../common/components/actionConfirmModal';
import PermissaoUsuario from '../../auth/permissao';
import { showUpdate, remove, setPaginaAtual } from './estoqueActions';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { filtrarPorAtivo, filtrarPorTexto, premiumBadge, renderSituacaoBadge } from '../manutencaoListUtils';

const FILTRO_TODOS = '';

class EstoqueList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroAtivo: FILTRO_TODOS,
      excluirItem: null,
    };
    this.removerItem = this.removerItem.bind(this);
    this.confirmarExclusaoItem = this.confirmarExclusaoItem.bind(this);
    this.cancelarExclusaoItem = this.cancelarExclusaoItem.bind(this);
    this.handleBuscaChange = this.handleBuscaChange.bind(this);
    this.handleAtivoChange = this.handleAtivoChange.bind(this);
  }

  handleBuscaChange(event) {
    this.setState({ filtroBusca: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handleAtivoChange(event) {
    this.setState({ filtroAtivo: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  removerItem(data) {
    this.setState({ excluirItem: data });
  }

  confirmarExclusaoItem() {
    const { excluirItem } = this.state;
    if (!excluirItem) return;
    this.props.remove(excluirItem);
    this.setState({ excluirItem: null });
  }

  cancelarExclusaoItem() {
    this.setState({ excluirItem: null });
  }

  renderFiltros() {
    const { filtroBusca, filtroAtivo } = this.state;

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="estoque-list-filtro-busca">
            Buscar
          </label>
          <input
            id="estoque-list-filtro-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={this.handleBuscaChange}
            placeholder="SKU ou descrição..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="estoque-list-filtro-ativo">
            Situação
          </label>
          <select
            id="estoque-list-filtro-ativo"
            className="form-control os-list-filter-select"
            value={filtroAtivo}
            onChange={this.handleAtivoChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            <option value="1">Ativos</option>
            <option value="0">Inativos</option>
          </select>
        </div>
      </div>
    );
  }

  renderQuantidade(row) {
    const abaixo = parseFloat(row.original.quantidade_atual) < parseFloat(row.original.quantidade_minima);
    if (abaixo) {
      return premiumBadge(row.value, 'os-badge--red');
    }
    return <span>{row.value}</span>;
  }

  render() {
    const itens = this.props.list || [];
    const itensFiltrados = filtrarPorAtivo(
      filtrarPorTexto(itens, ['codigo', 'descricao'], this.state.filtroBusca),
      this.state.filtroAtivo,
    );

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="os-actions-cell">
            <div className="os-actions-group">
              <PermissaoUsuario tela="CadManutencaoEstoque" campo="alterar" condicao={true}>
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.props.showUpdate(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEstoque" campo="excluir" condicao={true}>
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.removerItem(row.original)}
                />
              </PermissaoUsuario>
            </div>
          </div>
        ),
        className: 'column_icon',
        width: 80,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'SKU',
        accessor: 'codigo',
        width: 110,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-numero">{row.value}</span>,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        minWidth: 220,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value}</span>,
      },
      {
        Header: 'Un.',
        accessor: 'unidade',
        width: 70,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Qtd. atual',
        accessor: 'quantidade_atual',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => this.renderQuantidade(row),
      },
      {
        Header: 'Qtd. mín.',
        accessor: 'quantidade_minima',
        width: 90,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Situação',
        accessor: 'ativo',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => renderSituacaoBadge(row.value, { ativoLabel: 'Ativo', inativoLabel: 'Inativo' }),
      },
    ];

    return (
      <div className="manutencao-premium-list table-container">
        <div className="os-list-top-panel">
          <p className="os-list-summary">{`${itensFiltrados.length} item(ns) em estoque`}</p>
          {this.renderFiltros()}
        </div>
        <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
          <ReactTableGT2A
            data={itensFiltrados}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={15}
            showPagination
            filterable={false}
            onPageChange={this.handlePageChange}
            page={this.props.paginaAtual}
            minRows={0}
          />
        </PremiumTableShell>

        <ActionConfirmModal
          show={!!this.state.excluirItem}
          title="Deseja realmente excluir?"
          message="O item será removido permanentemente do cadastro de estoque."
          itemName={
            this.state.excluirItem
              ? `${this.state.excluirItem.codigo || ''}${this.state.excluirItem.descricao ? ` — ${this.state.excluirItem.descricao}` : ''}`
              : ''
          }
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoItem}
          onCancel={this.cancelarExclusaoItem}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoEstoque.list,
  paginaAtual: state.manutencaoEstoque.paginaAtual,
});
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, setPaginaAtual }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EstoqueList);
